export const getDocumentScrollTop = () => {
  const el = document.scrollingElement || document.documentElement;
  return el.scrollTop;
};

export const setDocumentScrollTop = (top) => {
  const el = document.scrollingElement || document.documentElement;
  el.scrollTop = top;
};
